import PropTypes from "prop-types";
import { StyledLink } from "./Link.styles";

const Link = (props) => {
    return <StyledLink {...props} />;
};

Link.propTypes = {
    variant: PropTypes.string,
    color: PropTypes.string,
};

export default Link;
